import { render, staticRenderFns } from "./playboard-service-audit-details.component.vue?vue&type=template&id=08021394&scoped=true"
import script from "./playboard-service-audit-details.component.vue?vue&type=script&lang=ts"
export * from "./playboard-service-audit-details.component.vue?vue&type=script&lang=ts"
import style0 from "./playboard-service-audit-details.component.vue?vue&type=style&index=0&id=08021394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08021394",
  null
  
)

export default component.exports